import '../index.css';
var styles = {
  "container": "bp_input_chip_module_container--482bc",
  "avatarContainer": "bp_input_chip_module_avatarContainer--482bc",
  "deleteButton": "bp_input_chip_module_deleteButton--482bc",
  "error": "bp_input_chip_module_error--482bc",
  "avatar": "bp_input_chip_module_avatar--482bc",
  "label": "bp_input_chip_module_label--482bc",
  "deleteIcon": "bp_input_chip_module_deleteIcon--482bc"
};
export { styles as default };